// extracted by mini-css-extract-plugin
export default {"icon":"iconlink_icon__1WCg5","action":"iconlink_action__BDkNb"};